module.exports = __webpack_public_path__ + "img/img_4.5d255fe1.png";